<h4 id="upper" class="card-title">Paramétrage Global</h4>

<div class="container mt-5">
  <div class="card shadow-sm">
    <div class="card-body">

      <!-- Nom de la commune -->
      <div class="row align-items-center g-2 mb-3">
        <div class="col-md-3 fw-bold">
          <label for="commune">Nom de la Commune</label>
        </div>
        <div class="col-md-6">
          <input type="text" id="commune" class="form-control" [(ngModel)]="commune" name="commune"
            placeholder="Entrez la commune" />
        </div>
        <div class="col-md-3">
          <button class="btn btn-primary w-100" (click)="saveCommune()">
            Enregistrer
          </button>
        </div>
      </div>

      <!-- Informations de contact -->
      <h6 class="mt-4 mb-3 fw-bold text-primary">Informations de contact</h6>

      <div class="row g-3 mb-3">
        <div class="col-md-4">
          <input type="tel" class="form-control" [(ngModel)]="telephone" name="telephone"
            placeholder="Numéro de téléphone" />
        </div>

        <div class="col-md-4">
          <input type="email" class="form-control" [(ngModel)]="email" name="email" placeholder="Adresse email" />
        </div>

        <div class="col-md-4">
          <input type="text" class="form-control" [(ngModel)]="ville" name="ville" placeholder="Ville" />
        </div>
      </div>

      <!-- Réseaux sociaux -->
      <h6 class="mt-4 mb-3 fw-bold text-primary">Liens des réseaux sociaux</h6>

      <div class="row g-3 mb-4">
        <div class="col-md-4">
          <input type="url" class="form-control" [(ngModel)]="linkedin_link" name="linkedin"
            placeholder="Lien LinkedIn" />
        </div>

        <div class="col-md-4">
          <input type="url" class="form-control" [(ngModel)]="facebook_link" name="facebook"
            placeholder="Lien Facebook" />
        </div>

        <div class="col-md-4">
          <input type="url" class="form-control" [(ngModel)]="youtube_link" name="youtube" placeholder="Lien YouTube" />
        </div>
      </div>

      <!-- Zone Drag & Drop -->
      <div class="upload-container text-center" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">
        <input type="file" #fileInput accept="image/png" (change)="onFileSelected($event)" hidden />

        <div class="upload-box border rounded p-4" (click)="triggerFileInput()">
          <i class="pi pi-cloud-upload text-primary" style="font-size: 2rem"></i>
          <p class="mb-0">
            Glissez-déposez un fichier ici ou cliquez pour importer un logo
          </p>
        </div>
      </div>

      <!-- Fichier sélectionné -->
      <p *ngIf="fileName" class="mt-2 text-success text-center">
        <strong>Fichier sélectionné :</strong> {{ fileName }}
      </p>

    </div>
  </div>
</div>

<p-toast position="center" />
<ngx-ui-loader></ngx-ui-loader>